import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-patients',
    templateUrl: './patients.component.html',
    styleUrls: ['./patients.component.css'],
    standalone: false
})
export class PatientsComponent implements OnInit {
  page = 1;
  pageSize = 10;
  readonly newFileOpeningFee = 4;

  list_length = 0;
  items: any[] = [];
  doctors: any[] = [];
  services: any[] = [];
  slots: any[] = [];
  doctor_slots: any[] = [];
  packages: any[] = [];
  packages_list: any[] = [];

  token: any;

  patient_id = 0;
  PatientName = '';
  order: any = false;

  item = {
    first_name: null,
    last_name: null,
    gender: '0',
    birth_date: '',
    address: null,
    visiting_reason: null,
    phone: null,
    phone2: null,
    email: null,
    national_id: null
  }

  edit_item = {
    first_name: null,
    last_name: null,
    gender: '',
    birth_date: '',
    address: null,
    visiting_reason: null,
    phone: null,
    phone2: null,
    email: null,
    national_id: null
  }

  appointment = {
    date: '',
    doctor_id: null,
    patient_id: null,
    active: false,
    notes: '',
    service: '',
    price: 0,
    amount_due: 0,
    period: 30,
    walkin: false,
    overbooked: false
  }

  is_package: boolean = false;
  package = {
    package_id: null,
    no_sessions: 0,
    session_price: 0,
    service_name: null,
    service_id: null,
    name: null
  }

  user_id: any;

  Swal = 'sweetalert2'

  schedual_id: any;
  appointment_id: any;

  constructor(public utility: UtilitiesService, private modalService: NgbModal, public api: ApiService, private route: ActivatedRoute, public datepipe: DatePipe, private router: Router, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.user_id = localStorage.getItem('id');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;
      let doctor = params['doctor'] != null ? params['doctor'] : null;

      this.getItems(id, doctor);
    });
  }

  private isPatientFormValid(form: { first_name: any; last_name: any; phone: any; birth_date: any }): boolean {
    return !!(
      form.first_name?.toString().trim() &&
      form.last_name?.toString().trim() &&
      form.phone?.toString().trim() &&
      form.birth_date?.toString().trim()
    );
  }

  get isNewPatientFormValid(): boolean {
    return this.isPatientFormValid(this.item);
  }

  get isEditPatientFormValid(): boolean {
    return this.isPatientFormValid(this.edit_item);
  }

  open(content: any, id?: any) {
    var date = new Date();
    var month = (date.getMonth() + 1).toString();
    var day = (date.getDate()).toString();

    if (+month < 10)
      month = '0' + month;

    if (+day < 10)
      day = '0' + day;

    this.appointment.date = date.getFullYear() + '-' + month + '-' + day + ' 08:00';

    if (id) this.appointment.patient_id = id;

    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.modalService.open(content);
    let getPatient = item

    this.edit_item = getPatient;
    this.patient_id = getPatient.id;

    var date = new Date(this.edit_item.birth_date);
    var month = (date.getMonth() + 1).toString();
    var day = (date.getDate()).toString();

    if (+month < 10)
      month = '0' + month;

    if (+day < 10)
      day = '0' + day;

    this.edit_item.birth_date = date.getFullYear() + '-' + month + '-' + day;
    this.edit_item.gender = item.gender == 'Male' ? '0' : '1';
  }

  async getItems(id?: any, doctor?: any) {
    this.utility.loading = true;
    const sub = this.api.get('patients/', this.token).subscribe(
      async data => {

        let objects: any = {}
        objects = data;

        this.items = objects;

        if (doctor)
          this.items = this.items.filter(i => i.doctor_id === doctor);

        this.items.forEach((item) => {
          if (!Number.isNaN(Date.parse(item.birth_date))) {
            let dob: any = new Date(item.birth_date);
            let today: any = new Date()
            let timediff = Math.abs(today - dob);
            let Age = Math.floor((timediff / (1000 * 3600 * 24)) / 365);

            item.age = Age;
          }
        });

        this.list_length = this.items.length;
      },
      async error => { }
    );

    sub.add(() => { this.getDoctors(); });
  }

  getDoctors() {
    let doctors = localStorage.getItem('doctors');

    if (doctors) {
      this.doctors = JSON.parse(doctors);
      this.getServices();
    }

    // const sub = this.api.get('employees/role/doctor', this.token).subscribe(
    //   async data => {
    //     let objects: any = {}
    //     objects = data;
    //     this.doctors = objects;
    //   },
    //   async error => { }
    // );
    // sub.add(() => { this.getServices(); });
  }

  getServices() {
    const sub = this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.services = objects;
      },
      async error => { }
    );
    sub.add(() => { this.getPackages(); });
  }

  async getPackages() {
    const sub = this.api.get('packages/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.packages = objects;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  async onDelete(id: any) {
    if (confirm("Are sure you want to delete the Patient?")) {
      const sub = this.api.delete('patients/' + id, this.token).subscribe(
        async data => {
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.getItems(); });
    }
  }

  async OnSumbit() {
    if (!this.isNewPatientFormValid) {
      Swal.fire({
        title: 'Missing required fields',
        text: 'Please fill in Name, Last Name, Phone, and Birth Date.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }

    const { value: selectedAmount } = await Swal.fire({
      title: 'Select payment to open new file',
      text: 'Choose the amount to charge for the new patient file.',
      icon: 'info',
      input: 'radio',
      inputOptions: {
        [this.newFileOpeningFee]: `Pay ${this.newFileOpeningFee} OMR`,
        0: 'Pay 0 OMR'
      },
      inputValue: this.newFileOpeningFee.toString(),
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'Please select a payment amount.';
        }

        return null;
      }
    });

    if (selectedAmount) {
      const fileOpeningAmount = +selectedAmount;
      let gender = 'Male';
      if (this.item.gender == '1')
        gender = 'Female';

      const body = {
        first_name: this.item.first_name,
        last_name: this.item.last_name,
        gender: gender,
        birth_date: this.item.birth_date,
        address: this.item.address,
        visiting_reason: this.item.visiting_reason,
        phone: this.item.phone,
        phone2: this.item.phone2,
        email: this.item.email,
        national_id: this.item.national_id,
        country: 'Oman'
      }

      const sub = this.api.post("patients/", body, this.token).subscribe(
        async data => {
          // create invoice...
          let obj: any = data;
          let patient: any = body;

          patient.number = obj.number;
          patient.id = obj.id;

          this.createFileInvoice(patient, fileOpeningAmount);

          Swal.fire({
            title: 'Success!',
            text: 'Created Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.getItems(); });
    }

    this.modalService.dismissAll();
  }

  createFileInvoice(patient: any, amountToPay: number) {
    let details: any = {}
    
    let patient_ = {
      patient_name: patient.first_name + ' ' + patient.last_name,
      patient_number: patient.number,
      patient_phone: patient.phone,
      patient_address: patient.address
    }

    let payment_services = {
      service_name: 'New Patient File',
      service_price: this.newFileOpeningFee,
      final_price: amountToPay,
      quantity: 1
    }

    details.patient = patient_;
    details.payment_services = payment_services;

    const body = {
      appointment_id: null,
      client_id: patient.id,
      final_price: amountToPay,
      service_price: this.newFileOpeningFee,
      payment_type: 'CASH',
      is_package: false,
      package_paid_amount: 0,
      payment_details: details
    }

    const sub = this.api.post("payments/", body, this.token).subscribe(
      async data => {
        // success message ...
        let objects: any = {}
        objects = data;

        let id = objects.id;

        this.router.navigate([]).then(result => { window.open('invoice_print?id=' + id, '_blank'); });
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => {
      this.modalService.dismissAll();
    });
  }

  async OnUpdate(id: any) {
    if (!this.isEditPatientFormValid) {
      Swal.fire({
        title: 'Missing required fields',
        text: 'Please fill in Name, Last Name, Phone, and Birth Date.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }

    let gender = 'Male';

    if (this.edit_item.gender == '1')
      gender = 'Female';

    const body = {
      first_name: this.edit_item.first_name,
      last_name: this.edit_item.last_name,
      gender: gender,
      birth_date: this.edit_item.birth_date,
      address: this.edit_item.address,
      visiting_reason: this.edit_item.visiting_reason,
      phone: this.edit_item.phone,
      phone2: this.edit_item.phone2,
      email: this.edit_item.email,
      national_id: this.edit_item.national_id,
      country: 'Oman'
    }

    this.api.update("patients/" + id, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  filterFunction(items: any[]) {
    const searchText = (this.PatientName || '').trim().toLowerCase();

    if (!searchText)
      return items;
    else
      return items.filter(i => i.first_name.toLowerCase().indexOf(searchText) >= 0 ||
        i.last_name.toLowerCase().indexOf(searchText) >= 0 ||
        i.patient_number.toLowerCase().indexOf(searchText) >= 0 ||
        i.phone != null && i.phone.toString() === searchText);
  }

  get filteredItems() {
    return this.filterFunction(this.items);
  }

  onSearchChange() {
    this.page = 1;
  }

  clearSearch() {
    this.PatientName = '';
    this.page = 1;
  }

  getDoctorSlots() {
    if (this.appointment.doctor_id) {
      const sub = this.api.get('schedules/' + this.appointment.doctor_id, this.token).subscribe(
        async data => {
          let objects: any = {}
          objects = data;

          this.slots = objects.schedules;
          this.doctor_slots = this.slots;
        },
        async error => { }
      );
      sub.add(() => { this.utility.loading = false; });
    }
  }

  dateSelection(slots: any[]) {
    let select_date = this.datepipe.transform(this.appointment.date, 'yyyy-MM-dd');
    return slots.filter(i => this.datepipe.transform(i.date_time, 'yyyy-MM-dd') === select_date);
  }

  createAppointment(content: any) {
    const body = {
      date_time: this.appointment.date,
      period: this.appointment.period,
      active: true,
      doctor_id: this.appointment.doctor_id
    }

    const sub = this.api.post("schedules/", body, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.schedual_id = objects.id;
        let amount_due = this.is_package ? this.package.session_price : this.appointment.amount_due;

        if (this.schedual_id) {
          const body = {
            date: this.appointment.date,
            period: this.appointment.period,
            notes: this.appointment.notes,
            service: this.package.service_name ? this.package.service_name : ' - ',
            service_id: this.appointment.service,
            patient_id: this.appointment.patient_id,
            doctor_id: this.appointment.doctor_id,
            slot_id: this.schedual_id,
            user_id: this.user_id,
            amount_due: amount_due, // check if there is package or not..
            walkin: this.appointment.walkin,
            overbooked: this.appointment.overbooked
          }

          const sub = this.api.post("appointments/", body, this.token).subscribe(
            async data => {
              // redirect to appointment details page...
              let appointment: any = data;
              this.appointment_id = appointment[0][0].id;

              // select package ...
              localStorage.removeItem('appointment');
              localStorage.setItem('appointment', JSON.stringify(appointment[0][0]));
              // check if the patient has package on this service... 
              // if yes pop-up
              if (this.common.appointment.has_pacakge || this.common.appointment.package == null) {
                Swal.fire({
                  title: 'Success!',
                  text: 'Appointment Added Successfuly!',
                  icon: 'success',
                  confirmButtonText: 'Cool'
                });
                this.modalService.dismissAll();
              }
              else if (!this.common.appointment.has_pacakge || this.common.appointment.package != null)
                this.modalService.open(content);
            },
            async error => {
              Swal.fire({
                title: 'Error!',
                text: 'Error making the appointment :(',
                icon: 'error',
                confirmButtonText: 'Ok'
              });

              this.common.deleteSchedual(this.schedual_id);
            }
          );

          sub.add(() => { this.getItems(); });
        }
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );
  }

  goToDetails(appointment: any) {
    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));

    this.router.navigate(['view_details']);
  }

  sort(value: string) {
    if (value == 'name') {
      if (!this.order) {
        this.items.sort((a, b) => a.first_name.localeCompare(b.first_name));
        this.order = true;
      }
      else {
        this.items.sort((a, b) => b.first_name.localeCompare(a.first_name));
        this.order = false;
      }
    }

    if (value == 'id') {
      if (!this.order) {
        this.items.sort((a, b) => { return a.id - b.id; });
        this.order = true;
      }
      else {
        this.items.sort((a, b) => { return b.id - a.id; });
        this.order = false;
      }
    }
  }

  getPrice() {
    if (this.appointment.service != null) {
      let service = this.services.find(i => i.id === this.appointment.service);

      this.appointment.price = service?.price;
      this.appointment.amount_due = service ? service.price : 0;
      this.package.service_name = service.name;

      this.packages_list = this.packages.filter(i => i.service_id === service.id);
      
      this.common.checkPackagesServices(this.appointment.patient_id, service.id);
    }
  }

  onChangePackage() {
    if (this.package.package_id != null) {
      this.is_package = true;

      let package_ = this.packages.find(i => i.id === this.package.package_id);
      this.package.no_sessions = package_.no_sessions;
      this.package.name = package_.name;
      this.package.service_id = package_.service_id;
      this.package.session_price = package_.session_price;
    }
    else {
      this.is_package = false;

      this.package = {
        package_id: null,
        no_sessions: 0,
        session_price: 0,
        service_name: null,
        service_id: null,
        name: null
      }
    }
  }

  OnSumbitPackage() {
    if (this.package.package_id) {
      let body = {
        package_id: this.package.package_id,
        patient_id: this.appointment.patient_id,
        full_price: (+this.appointment.amount_due * +this.package.no_sessions),
        session_price: this.appointment.amount_due,
        service_name: this.package.service_name,
        service_id: this.package.service_id,
        paied_amount: 0,
        no_sessions: this.package.no_sessions,
        no_sessions_left: this.package.no_sessions,
        no_sessions_took: 0
      }

      this.api.post("package_patients/", body, this.token).subscribe(
        async data => {
          Swal.fire({
            title: 'Success!',
            text: `Appointment with ${this.package.name} Package Added Successfuly!`,
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });

          this.common.deleteSchAppointment(this.schedual_id, this.appointment_id);
        }
      );

    }
    else {
      Swal.fire({
        title: 'Success!',
        text: 'Appointment Added Successfuly!',
        icon: 'success',
        confirmButtonText: 'Cool'
      })
    }

    this.modalService.dismissAll();
  }
}